import React, { ReactElement } from "react";

import { PAGE_URL } from "../../../value/Url";

import { ReactComponent as SideMenuDashboardImg } from "../../../img/ico-side-bar-menu-dashboard.svg";
import { ReactComponent as SideMenuDashboardActiveImg } from '../../../img/ico-side-bar-menu-dashboard-active.svg';
import { ReactComponent as SideMenuInfraImg } from "../../../img/ico-side-bar-menu-infra-mgmt.svg";
import { ReactComponent as SideMenuInfraActiveImg } from '../../../img/ico-side-bar-menu-infra-mgmt-active.svg';
import { ReactComponent as SideMenuResourceImg } from '../../../img/ico-side-bar-menu-resource.svg';
import { ReactComponent as SideMenuResourceActiveImg } from '../../../img/ico-side-bar-menu-resource-active.svg';
import { ReactComponent as SideMenuPhysicalInActiveImg } from '../../../img/ico-side-bar-menu-physical-res.svg';
import { ReactComponent as SideMenuPhysicalActiveImg } from '../../../img/ico-side-bar-menu-physical-res-active.svg';
import { ReactComponent as SideMenuLogicalInActiveImg } from '../../../img/ico-side-bar-menu-logical-res.svg';
import { ReactComponent as SideMenuLogicalActiveImg } from '../../../img/ico-side-bar-menu-logical-res-active.svg';
import { ReactComponent as SideMenuContainerLogicalInActiveImg } from '../../../img/ico-side-bar-menu-container-platform-logical-res.svg';
import { ReactComponent as SideMenuContainerLogicalActiveImg } from '../../../img/ico-side-bar-menu-container-platform-logical-res-active.svg';
import { ReactComponent as SideMenuVirtualInstanceMgmtInActiveImg } from '../../../img/ico-side-bar-menu-virtual-instance-mgmt.svg';
import { ReactComponent as SideMenuVirtualInstanceMgntActiveImg } from '../../../img/ico-side-bar-menu-virtual-instance-mgmt-active.svg';
import { ReactComponent as SideMenuVirtualInstanceUsageInActiveImg } from '../../../img/ico-side-bar-menu-virtual-instance-usage.svg';
import { ReactComponent as SideMenuvirtualInstanceUsageActiveImg } from '../../../img/ico-side-bar-menu-virtual-instance-usage-active.svg';
import { ReactComponent as SideMenuContainerClusterInActiveImg } from '../../../img/ico-side-bar-menu-container-platform-cluster.svg';
import { ReactComponent as SideMenuContainerClusterActiveImg } from '../../../img/ico-side-bar-menu-container-platform-cluster-active.svg';
import { ReactComponent as SideMenuApplicationAccountInActiveImg } from '../../../img/ico-side-bar-menu-application-management.svg';
import { ReactComponent as SideMenuApplicationAccountActiveImg } from '../../../img/ico-side-bar-menu-application-management-active.svg';
import { ReactComponent as SideMenuLogInActiveImg } from '../../../img/ico-side-bar-menu-log.svg';
import { ReactComponent as SideMenuLogActiveImg } from '../../../img/ico-side-bar-menu-log-active.svg';
import { ReactComponent as SideMenuSettingInActiveImg } from '../../../img/ico-side-bar-menu-setting.svg';
import { ReactComponent as SideMenuSettingActiveImg } from '../../../img/ico-side-bar-menu-setting-active.svg';


import i18n from "../../../lang/base";

export interface SideBarItemData {
    id: number,
    name: string,
    path: string,
    imgComponent: ReactElement,
    activeImgComponent: ReactElement,
    sub: SideBarSubItemData[]
}

export interface SideBarSubItemData {
    id: number,
    name: string,
    path: string,
}

export const SideBarMenus:SideBarItemData[] = [
    // 대시보드
    {
        id: 1,
        name: i18n.t("MENU_DASHBOARD"),
        path: PAGE_URL.DASHBOARD,
        imgComponent: <SideMenuDashboardImg />,
        activeImgComponent: <SideMenuDashboardActiveImg />,
        sub: [],
    },
    // 인프라 자원 관리
    // {
    //     id: 1,
    //     name: i18n.t("INFRA_RESOURCE_MANAGER"),
    //     path: "",
    //     imgComponent: <SideMenuInfraImg />,
    //     activeImgComponent: <SideMenuInfraActiveImg />,
    //     sub: [
    //         // Rack 실장도
    //         {
    //             id: 1,
    //             name: i18n.t("INFRA_RESOURCE_MANAGER_DASHBOARD"),
    //             path: PAGE_URL.INFRA_RESOURCE_MANAGER_DASHBOARD,
    //         },
    //         // Rack 실장도
    //         {
    //             id: 2,
    //             name: i18n.t("INFRA_RESOURCE_MANAGER_RACKIMAGE"),
    //             path: PAGE_URL.INFRA_RESOURCE_MANAGER_RACKIMAGE,
    //         }
    //     ],
    // },
    // 가상화 자원 관리
    {
        id: 2,
        name: i18n.t("MENU_VIRTUAL_RESOURCE_GROUP"),
        path: "",
        imgComponent: <SideMenuResourceImg />,
        activeImgComponent: <SideMenuResourceActiveImg />,
        sub: [
            // 리전 관리
            {
                id: 1,
                name: i18n.t("MENU_VIRTUAL_RESOURCE_GROUP_REGION"),
                path: PAGE_URL.VIRTUAL_RESOURCE_GROUP_REGION,
            },
            // 호스트 클러스터 관리
            {
                id: 2,
                name: i18n.t("MENU_VIRTUAL_RESOURCE_GROUP_HOST_CLUSTER"),
                path: PAGE_URL.VIRTUAL_RESOURCE_GROUP_HOST_CLUSTER,
            },
            // AZ 관리
            {
                id: 3,
                name: i18n.t("MENU_VIRTUAL_RESOURCE_GROUP_AZ"),
                path: PAGE_URL.VIRTUAL_RESOURCE_GROUP_AZ,
            },
        ],
    },
    // 가상화 플랫폼 물리 리소스 관리
    {
        id: 3,
        name: i18n.t("MENU_VIRTUAL_PHYSICAL_RESOURCE"),
        path: "",
        imgComponent: <SideMenuPhysicalInActiveImg />,
        activeImgComponent: <SideMenuPhysicalActiveImg />,
        sub: [
            // 호스트 관리
            {
                id: 1,
                name: i18n.t("MENU_VIRTUAL_PHYSICAL_RESOURCE_HOST"),
                path: PAGE_URL.VIRTUAL_PHYSICAL_RESOURCE_HOST,
            },
            // 스토리지 관리
            {
                id: 2,
                name: i18n.t("MENU_VIRTUAL_PHYSICAL_RESOURCE_STORAGE"),
                path: PAGE_URL.VIRTUAL_PHYSICAL_RESOURCE_STORAGE,
            },
        ],
    },
    // 응용 관리
    {
        id: 4,
        name: i18n.t("MENU_APPLICATION"),
        path: "",
        imgComponent: <SideMenuApplicationAccountInActiveImg />,
        activeImgComponent: <SideMenuApplicationAccountActiveImg />,
        sub: [
            // 나의 정보
            {
                id: 1,
                name: i18n.t("MENU_APPLICATION_MY_INFO"),
                path: PAGE_URL.APPLICATION_MY_INFO,
            },
            // 계정 관리
            {
                id: 2,
                name: i18n.t("MENU_APPLICATION_ACCOUNT"),
                path: PAGE_URL.APPLICATION_ACCOUNT,
            },
            // 프로젝트 관리
            {
                id: 3,
                name: i18n.t("MENU_APPLICATION_PROJECT"),
                path: PAGE_URL.APPLICATION_PROJECT,
            },
            // SMTP 관리
            {
                id: 4,
                name: i18n.t("MENU_APPLICATION_SMTP"),
                path: PAGE_URL.APPLICATION_SMTP,
            },
        ],
    },
    // 가상화 플랫폼 논리 리소스 관리
    {
        id: 5,
        name: i18n.t("MENU_VIRTUAL_LOGICAL_RESOURCE"),
        path: "",
        imgComponent: <SideMenuLogicalInActiveImg />,
        activeImgComponent: <SideMenuLogicalActiveImg />,
        sub: [
            // 가상 머신 이미지 관리
            {
                id: 1,
                name: i18n.t("MENU_VIRTUAL_LOGICAL_RESOURCE_IMAGE"),
                path: PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_IMAGE,
            },
            // 가상머신 사양 관리
            {
                id: 2,
                name: i18n.t("MENU_VIRTUAL_LOGICAL_RESOURCE_PERFORMANCE"),
                path: PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_PERFORMANCE,
            },
            // 네트워크 관리
            {
                id: 3,
                name: i18n.t("MENU_VIRTUAL_LOGICAL_RESOURCE_NETWORK"),
                path: PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_NETWORK,
            },
            // 라우터 관리
            {
                id: 4,
                name: i18n.t("MENU_VIRTUAL_LOGICAL_RESOURCE_ROUTER"),
                path: PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_ROUTER,
            },
            // // 네트워크 토폴로지 그림
            {
                id: 5,
                name: i18n.t("MENU_VIRTUAL_LOGICAL_RESOURCE_NETWORK_TOPOLOGY"),
                path: PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_NETWORK_TOPOLOGY,
            },
            // 보안 그룹 관리
            {
                id: 6,
                name: i18n.t("MENU_VIRTUAL_LOGICAL_RESOURCE_SECURITY"),
                path: PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_SECURITY,
            },
            // 유동 IP 관리
            {
                id: 7,
                name: i18n.t("MENU_VIRTUAL_LOGICAL_RESOURCE_IP"),
                path: PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_IP,
            },
            // 키페어 관리
            {
                id: 8,
                name: i18n.t("MENU_VIRTUAL_LOGICAL_RESOURCE_KEY_PAIR"),
                path: PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_KEY_PAIR,
            },
        ],
    },
    // // 가상화 플랫폼 가상 인스턴스 관리
    {
        id: 6,
        name: i18n.t("MENU_VIRTUAL_INSTANCE_MGMT"),
        path: "",
        imgComponent: <SideMenuVirtualInstanceMgmtInActiveImg />,
        activeImgComponent: <SideMenuVirtualInstanceMgntActiveImg />,
        sub: [
            // 가상머신 관리
            {
                id: 1,
                name: i18n.t("MENU_VIRTUAL_INSTANCE_MGMT_VM"),
                path: PAGE_URL.VIRTUAL_INSTANCE_MGMT_VM,
            },
            // 가상머신 백업이미지 관리
            {
                id: 2,
                name: i18n.t("MENU_VIRTUAL_INSTANCE_MGMT_VM_BACKUP_IMAGE"),
                path: PAGE_URL.VIRTUAL_INSTANCE_MGMT_VM_BACKUP_IMAGE,
            },
            // 가상머신 볼륨 관리
            {
                id: 3,
                name: i18n.t("MENU_VIRTUAL_INSTANCE_MGMT_VOLUMNE"),
                path: PAGE_URL.VIRTUAL_INSTANCE_MGMT_VOLUMNE,
            },
        ],
    },
    // // 컨테이너 플랫폼 논리 리소스 관리
    {
        id: 7,
        name: i18n.t("MENU_CONTAINER_LOGICAL_RESOURCE"),
        path: "",
        imgComponent: <SideMenuContainerLogicalInActiveImg/>,
        activeImgComponent: <SideMenuContainerLogicalActiveImg />,
        sub: [
            // 컨테이너 응용 클러스터 관리
            {
                id: 1,
                name: i18n.t("MENU_CONTAINER_LOGICAL_RESOURCE_CLUSTER_TEMPLATE"),
                path: PAGE_URL.CONTAINER_LOGICAL_RESOURCE_CLUSTER_TEMPLATE,
            },
            // 컨테이너 응용 클러스터 관리
            {
                id: 2,
                name: i18n.t("MENU_CONTAINER_LOGICAL_RESOURCE_CLUSTER"),
                path: PAGE_URL.CONTAINER_LOGICAL_RESOURCE_CLUSTER,
            },
            // 컨테이너 응용 노드 관리
            {
                id: 3,
                name: i18n.t("MENU_CONTAINER_LOGICAL_RESOURCE_NODE"),
                path: PAGE_URL.CONTAINER_LOGICAL_RESOURCE_NODE,
            },
            // 이미지 저장소 관리
            {
                id: 4,
                name: i18n.t("MENU_CONTAINER_LOGICAL_RESOURCE_IMAGE_STORAGE"),
                path: PAGE_URL.CONTAINER_LOGICAL_RESOURCE_REGISTRY,
            },
        ],
    },
    // 컨테이너 플랫폼 클러스터 관리
    {
        id: 8,
        name: i18n.t("MENU_CONTAINER_CLUSTER_MGMT"),
        path: "",
        imgComponent: <SideMenuContainerClusterInActiveImg />,
        activeImgComponent: <SideMenuContainerClusterActiveImg />,
        sub: [
            // 컨테이너 응용 네임스페이스 관리
            {
                id: 1,
                name: i18n.t("MENU_CONTAINER_CLUSTER_MGMT_NAMESPACE"),
                path: PAGE_URL.CONTAINER_CLUSTER_MGMT_NAMESPACE,
            },
            // 컨테이너 이미지 관리"
            {
                id: 2,
                name: i18n.t("MENU_CONTAINER_CLUSTER_MGMT_IMAGE"),
                path: PAGE_URL.CONTAINER_CLUSTER_MGMT_IMAGE,
            },
            // 컨테이너 응용 파드 프로파일 관리
            {
                id: 3,
                name: i18n.t("MENU_CONTAINER_CLUSTER_MGMT_POD_PROFILE"),
                path: PAGE_URL.CONTAINER_CLUSTER_MGMT_POD_PROFILE,
            },
            // 컨테이너 응용 배포 관리
            {
                id: 4,
                name: i18n.t("MENU_CONTAINER_CLUSTER_MGMT_APPLICATION_DEPLOYMENT"),
                path: PAGE_URL.CONTAINER_CLUSTER_MGMT_APPLICATION_DEPLOYMENT,
            },
             // 컨테이너 응용 파드 관리
            {
                id: 5,
                name: i18n.t("MENU_CONTAINER_CLUSTER_MGMT_APPLICATION_POD"),
                path: PAGE_URL.CONTAINER_CLUSTER_MGMT_APPLICATION_POD,
            },
            // 컨테이너 응용 볼륨 관리
            {
                id: 6,
                name: i18n.t("MENU_CONTAINER_CLUSTER_MGMT_POD_VOLUME"),
                path: PAGE_URL.CONTAINER_CLUSTER_MGMT_POD_VOLUME,
            },
            // 컨테이너 응용 서비스 관리
            {
                id: 7,
                name: i18n.t("MENU_CONTAINER_CLUSTER_MGMT_SERVICE"),
                path: PAGE_URL.CONTAINER_CLUSTER_MGMT_SERVICE,
            },
            // 인그레스 관리
            {
                id: 8,
                name: i18n.t("MENU_CONTAINER_CLUSTER_MGMT_INGRESS"),
                path: PAGE_URL.CONTAINER_CLUSTER_MGMT_INGRESS,
            },
        ],
    },
    {
        id: 9,
        name: i18n.t("MENU_LOG"),
        path: PAGE_URL.LOG_AUDIT,
        imgComponent: <SideMenuLogInActiveImg />,
        activeImgComponent: <SideMenuLogActiveImg />,
        sub: [],
    },
    {
        id: 10,
        name: i18n.t("MENU_SERVICE"),
        path: PAGE_URL.SERVICE_PRODUCT,
        imgComponent: <SideMenuLogInActiveImg />,
        activeImgComponent: <SideMenuLogActiveImg />,
        sub: [
            // 컨테이너 응용 네임스페이스 관리
            {
                id: 1,
                name: i18n.t("MENU_SERVICE_PRODUCT"),
                path: PAGE_URL.SERVICE_PRODUCT,
            },
            {
                id: 2,
                name: i18n.t("MENU_SERVICE_LICENSE"),
                path: PAGE_URL.SERVICE_LICENSE,
            },
            {
                id: 3,
                name: i18n.t("MENU_SERVICE_PURCHASE"),
                path: PAGE_URL.SERVICE_PURCHASE,
            },
            {
                id: 4,
                name: i18n.t("MENU_SERVICE_CLIENT_PACKAGE"),
                path: PAGE_URL.SERVICE_RDS_CLIENT_PACKAGE,
            },
            {
                id: 5,
                name: i18n.t("MENU_SERVICE_RDS_DEVICE"),
                path: PAGE_URL.SERVICE_RDS_DEVICE,
            },
        ],
    }
    // // 컨테이너 플랫폼 가상 인스턴스 사용
    // {
    //     id: 9,
    //     name: i18n.t("MENU_VIRTUAL_INSTANCE_USEAGE"),
    //     path: "",
    //     imgComponent: <SideMenuVirtualInstanceUsageInActiveImg />,
    //     activeImgComponent: <SideMenuvirtualInstanceUsageActiveImg />,
    //     sub: [
    //         // 가상머신 사용
    //         {
    //             id: 1,
    //             name: i18n.t("MENU_VIRTUAL_INSTANCE_USEAGE_VM"),
    //             path: PAGE_URL.VIRTUAL_INSTANCE_USEAGE_VM,
    //         },
    //         // 가상머신 디스크 사용
    //         {
    //             id: 2,
    //             name: i18n.t("MENU_VIRTUAL_INSTANCE_USEAGE_VM_DISK"),
    //             path: PAGE_URL.VIRTUAL_INSTANCE_USEAGE_VM_DISK,
    //         },
    //         // 가상머신 볼륨 사용
    //         {
    //             id: 3,
    //             name: i18n.t("MENU_VIRTUAL_INSTANCE_USEAGE_VM_VOLUME"),
    //             path: PAGE_URL.VIRTUAL_INSTANCE_USEAGE_VM_VOLUME,
    //         },
    //     ],
    // },
    // // 로그 관리
    // {
    //     id: 10,
    //     name: i18n.t("MENU_LOG"),
    //     path: "",
    //     imgComponent: <SideMenuLogInActiveImg />,
    //     activeImgComponent: <SideMenuLogActiveImg />,
    //     sub: [
    //         // 계정 관리
    //         {
    //             id: 1,
    //             name: i18n.t("MENU_LOG_MGMT"),
    //             path: PAGE_URL.LOG_MGMT,
    //         },
    //         // 도메인/프로젝트 관리
    //         {
    //             id: 2,
    //             name: i18n.t("MENU_LOG_AUDIT"),
    //             path: PAGE_URL.LOG_AUDIT,
    //         },
    //     ],
    // },
    //  // 시스템 설정
    //  {
    //     id: 11,
    //     name: i18n.t("MENU_SETTING"),
    //     path: "",
    //     imgComponent: <SideMenuSettingInActiveImg />,
    //     activeImgComponent: <SideMenuSettingActiveImg />,
    //     sub: [
    //         // 계정 관리
    //         {
    //             id: 1,
    //             name: i18n.t("MENU_SETTING_DEFAULT"),
    //             path: PAGE_URL.SETTING_DEFAULT,
    //         },
    //     ],
    // },
];